import React from 'react';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import SectionNoContent from '../Components/SectionNoContent';

const Regulatory = ({ contents }) => {
  console.log(contents)
  const storage = urlApi + '/storage/article/';

  const slides = [
    {
      row_value: Bg,
      detail:
        <>
          <h1 className='tx-color-secondary font-header fw-normal mb-0' style={{ lineHeight: 1.1 }}>Pioneering</h1>
          <h1 className='tx-color-primary font-header fw-normal' style={{ lineHeight: 1.1 }}>Global Legal<br />Excellence</h1>
          {/* <p className='tx-color-primary font-default'>ABER is the FIRST law firm legally accepting cryptocurrencies in Thailand.</p> */}
        </>
    }
  ];

  return (
    <>
      <SectionHeader topic='Regulatory Updates' detail='Get timely updates on important legal and regulatory changes that may impact your business or personal matters.' bg={Bg} />
      <SectionNoContent />
    </>
  )
}

Regulatory.defaultProps = {
  contents: {
    lang: 'th',
    content: {
      contents: []
    }
  },
  web_setup: {
    practice_topic: [],
    practice: []
  },
  path: '',
  lang: 'en'
}

export default Regulatory